import { useEffect, useState } from 'react';
import { DateTime as DT } from 'luxon';
import { useTranslation } from 'react-i18next';
import type { ObjectDiscussionMessageType } from '@econtractor/types';

interface DiscussionMessageProps {
    message: ObjectDiscussionMessageType;
}

const DiscussionMessage = ({ message }: DiscussionMessageProps) => {
    const { t } = useTranslation(['Objects']);
    const name = message.userName.trim() || t('discussion.unknownUser');
    const when = message.dt ? DT.fromMillis(message.dt) : null;
    const [src, setSrc] = useState(message.userPicture || '/imgs/user.png');

    useEffect(() => {
        setSrc(message.userPicture || '/imgs/user.png');
    }, [message.userPicture]);

    return (
        <article className="object-discussion__message">
            <div className="object-discussion__node">
                <img
                    className="awatar awatar-user awatar--small rounded-circle object-discussion__avatar"
                    src={src}
                    alt=""
                    onError={() => setSrc('/imgs/user.png')}
                />
            </div>
            <div className="object-discussion__content">
                <div className="object-discussion__head">
                    <div className="text-body fw-medium text-truncate user-name-item__name--small min-w-0">
                        {name}
                    </div>
                    {when?.isValid ? (
                        <div className="object-discussion__when">
                            <span className="d-block text-muted fs-12">
                                {when.toLocaleString(DT.DATE_MED)}
                            </span>
                            <time className="text-muted fs-12" dateTime={when.toISO() ?? undefined}>
                                {when.toLocaleString(DT.TIME_SIMPLE)}
                            </time>
                        </div>
                    ) : null}
                </div>
                <p className="object-discussion__body">{message.message}</p>
            </div>
        </article>
    );
};

export default DiscussionMessage;
